export interface UpgradeCheckoutOptions {
  paymentUrl: string;
  token: string;
  billingPeriod: 'Monthly' | 'Yearly';
  currency: string;
  planName: 'Pro' | 'Launch';
  isOfferActive?: boolean; // Currently unused for URL params based on Phase 1, but ready for future use
}

/**
 * Builds the canonical checkout URL for upgrading plans.
 * This is the single source of truth for all upgrade CTAs.
 */
export function buildUpgradeCheckoutUrl({
  paymentUrl,
  token,
  billingPeriod,
  currency,
  planName,
  isOfferActive,
}: UpgradeCheckoutOptions): string {
  // If the backend later supports a discounted plan name or promo code,
  // we will map it here based on `isOfferActive`.
  // e.g. const finalPlanName = isOfferActive && planName === 'Pro' ? 'Pro-Discounted-Monthly' : planName;
  
  const finalPlanName = planName;

  const finalCurrency = currency === 'INR' ? 'INR' : 'USD';

  return `${paymentUrl}/upgrade?token=${token}&billingPeriod=${billingPeriod}&currency=${finalCurrency}&selectedPlanName=${finalPlanName}`;
}
